import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { ToolbarComponent } from './toolbar.component';

@NgModule({
    declarations: [ToolbarComponent],
    imports: [
        FlexLayoutModule,
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
    ],
    exports: [ToolbarComponent]
})
export class ToolbarModule { }
